"use strict";
import React from "react";
function inputType(props) {
  return props.type || "text";
}
function label(props) {
  if (props.label) {
    return /* @__PURE__ */ React.createElement("label", { htmlFor: props.id }, props.label);
  }
}
function divClasses(props) {
  var classes = props.divClasses;
  if (props.errors) {
    classes += " error";
  }
  return classes;
}
function errorMessage(props) {
  var errors;
  if (errors = props.errors) {
    return /* @__PURE__ */ React.createElement("small", { className: "error" }, errors);
  }
}
function FormInput(props) {
  return /* @__PURE__ */ React.createElement("div", { "data-component": "FormInput", className: divClasses(props) }, label(props), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: inputType(props),
      placeholder: props.placeholder,
      onChange: props.onChange,
      onKeyDown: props.onKeyDown,
      value: props.value,
      checked: props.checked,
      id: props.id
    }
  ), errorMessage(props));
}
export default FormInput;
